export default __webpack_public_path__ + "static/media/nexodus-icon.845fdfb1.svg";